import {
	addResolvedPropertyMapping,
	addSelectableResolvedPropertyMapping,
	getResolvedProperty,
	getSelectorParts,
	removeResolvedMapping
} from '../property-selectors';
import {getHostVariables} from './index';
import {PROPERTY_DEFS} from '../symbols';
import resolveProviderSelectedProperty from '../property-selectors/resolveProviderSelectedProperty';
import shouldAddToResolvedPropertyMapping from './shouldAddToResolvedPropertyMapping';
import quickEquals from './helpers/quickEquals';
import getResolvedValue from './getResolvedValue';
import updateResolvedValue from './updateResolvedValue';

/**
 * function to update resolvedSelectedPropertyMapping so that we don't need to re-resolve the same property if found

 * @param propertyDetails
 * @param consumerPropName
 * @param consumerId
 * @param componentRegistry
 * @param propertyDef
 * @param propertiesWithSelector
 */
export default function updateResolvedSelectedPropertyMappings(
	propertyDetails,
	consumerPropName,
	consumerId,
	componentRegistry = {},
	propertyDef = {},
	propertiesWithSelector = {}
) {
	const {previousValue, value} = propertyDetails;
	const [previousProviderId, previousProviderPropName, previousProviderPath] =
		getSelectorParts(previousValue);
	const [providerId, providerPropName, providerPropPath] = getSelectorParts(value);
	if (previousProviderId && previousProviderPropName) {
		if (!shouldAddToResolvedPropertyMapping(previousValue, componentRegistry)) return;
		//when the property value has been resolved and added to the mapping
		//if the new value is different, need to update the mapping accordingly
		const [id] = propertiesWithSelector[consumerPropName];
		const alreadyResolvedValue = getResolvedProperty(id);
		if (
			alreadyResolvedValue &&
			!quickEquals(getResolvedValue(alreadyResolvedValue, previousProviderPath, propertyDef), value)
		) {
			const newValue = updateResolvedValue(alreadyResolvedValue, previousProviderPath, value);
			removeResolvedMapping(previousProviderId, previousProviderPropName, newValue);
			addResolvedPropertyMapping(
				{providerId: previousProviderId, providerPropName: previousProviderPropName},
				newValue
			);
		}
	} else if (providerId && providerPropName) {
		if (!shouldAddToResolvedPropertyMapping(value, componentRegistry)) return;

		const resolvedValue = resolveProviderSelectedProperty(
			value,
			providerPropPath,
			componentRegistry,
			propertyDef
		);
		removeResolvedMapping(providerId, providerPropName, resolvedValue);
		addResolvedPropertyMapping({providerId, providerPropName}, resolvedValue);
	} else if (consumerId && consumerPropName) {
		// when providerId & providerPropName is empty, it means that consumer itself is a provider when it's selectable
		const consumerComponent = componentRegistry[consumerId];
		if (!consumerComponent) return;

		const consumerPropDef = getHostVariables(consumerComponent)[PROPERTY_DEFS];
		if (consumerPropDef[consumerPropName]?.selectable) {
			removeResolvedMapping(consumerId, consumerPropName, value);
			addSelectableResolvedPropertyMapping({consumerId, consumerPropName}, value);
		}
	}
}
